var $page = $("html, body");

        $(".social-proof-button").click(function (e) {

            $page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function () {
                $page.stop();
            });

            $page.animate({ scrollTop: $($(this).attr('href')).offset().top }, 'slow', function () {
                $page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
            });

            return false;
        });